/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress } from './ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress';
import {
    ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressFromJSON,
    ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressFromJSONTyped,
    ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressToJSON,
} from './ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress';
import type { ExecRiskBusinessName } from './ExecRiskBusinessName';
import {
    ExecRiskBusinessNameFromJSON,
    ExecRiskBusinessNameFromJSONTyped,
    ExecRiskBusinessNameToJSON,
} from './ExecRiskBusinessName';
import type { ExecRiskForeignAddress } from './ExecRiskForeignAddress';
import {
    ExecRiskForeignAddressFromJSON,
    ExecRiskForeignAddressFromJSONTyped,
    ExecRiskForeignAddressToJSON,
} from './ExecRiskForeignAddress';

/**
 * 
 * @export
 * @interface ExecRiskIdDisregardedEntities
 */
export interface ExecRiskIdDisregardedEntities {
    /**
     * 
     * @type {ExecRiskBusinessName}
     * @memberof ExecRiskIdDisregardedEntities
     */
    disregarded_entity_name?: ExecRiskBusinessName;
    /**
     * 
     * @type {ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress}
     * @memberof ExecRiskIdDisregardedEntities
     */
    us_address?: ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress;
    /**
     * 
     * @type {ExecRiskForeignAddress}
     * @memberof ExecRiskIdDisregardedEntities
     */
    foreign_address?: ExecRiskForeignAddress;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdDisregardedEntities
     */
    ein?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdDisregardedEntities
     */
    primary_activities_txt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdDisregardedEntities
     */
    legal_domicile_state_cd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdDisregardedEntities
     */
    legal_domicile_foreign_country_cd?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskIdDisregardedEntities
     */
    total_income_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskIdDisregardedEntities
     */
    end_of_year_assets_amt?: number;
    /**
     * 
     * @type {ExecRiskBusinessName}
     * @memberof ExecRiskIdDisregardedEntities
     */
    direct_controlling_entity_name?: ExecRiskBusinessName;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdDisregardedEntities
     */
    direct_controlling_na_cd?: string;
}

/**
 * Check if a given object implements the ExecRiskIdDisregardedEntities interface.
 */
export function instanceOfExecRiskIdDisregardedEntities(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskIdDisregardedEntitiesFromJSON(json: any): ExecRiskIdDisregardedEntities {
    return ExecRiskIdDisregardedEntitiesFromJSONTyped(json, false);
}

export function ExecRiskIdDisregardedEntitiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskIdDisregardedEntities {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'disregarded_entity_name': !exists(json, 'disregarded_entity_name') ? undefined : ExecRiskBusinessNameFromJSON(json['disregarded_entity_name']),
        'us_address': !exists(json, 'us_address') ? undefined : ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressFromJSON(json['us_address']),
        'foreign_address': !exists(json, 'foreign_address') ? undefined : ExecRiskForeignAddressFromJSON(json['foreign_address']),
        'ein': !exists(json, 'ein') ? undefined : json['ein'],
        'primary_activities_txt': !exists(json, 'primary_activities_txt') ? undefined : json['primary_activities_txt'],
        'legal_domicile_state_cd': !exists(json, 'legal_domicile_state_cd') ? undefined : json['legal_domicile_state_cd'],
        'legal_domicile_foreign_country_cd': !exists(json, 'legal_domicile_foreign_country_cd') ? undefined : json['legal_domicile_foreign_country_cd'],
        'total_income_amt': !exists(json, 'total_income_amt') ? undefined : json['total_income_amt'],
        'end_of_year_assets_amt': !exists(json, 'end_of_year_assets_amt') ? undefined : json['end_of_year_assets_amt'],
        'direct_controlling_entity_name': !exists(json, 'direct_controlling_entity_name') ? undefined : ExecRiskBusinessNameFromJSON(json['direct_controlling_entity_name']),
        'direct_controlling_na_cd': !exists(json, 'direct_controlling_na_cd') ? undefined : json['direct_controlling_na_cd'],
    };
}

export function ExecRiskIdDisregardedEntitiesToJSON(value?: ExecRiskIdDisregardedEntities | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'disregarded_entity_name': ExecRiskBusinessNameToJSON(value.disregarded_entity_name),
        'us_address': ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressToJSON(value.us_address),
        'foreign_address': ExecRiskForeignAddressToJSON(value.foreign_address),
        'ein': value.ein,
        'primary_activities_txt': value.primary_activities_txt,
        'legal_domicile_state_cd': value.legal_domicile_state_cd,
        'legal_domicile_foreign_country_cd': value.legal_domicile_foreign_country_cd,
        'total_income_amt': value.total_income_amt,
        'end_of_year_assets_amt': value.end_of_year_assets_amt,
        'direct_controlling_entity_name': ExecRiskBusinessNameToJSON(value.direct_controlling_entity_name),
        'direct_controlling_na_cd': value.direct_controlling_na_cd,
    };
}

